interface SectionProps {
  id: string;
  /** Two-digit index shown in the rail, e.g. "01". */
  index: string;
  label: string;
  /** Large section heading. Omit for sections that supply their own. */
  title?: React.ReactNode;
  /** Optional standfirst under the title. */
  lead?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Editorial section frame: a sticky numbered rail on the left, content on the
 * right. The rail is what gives each section its sense of place while letting
 * the content areas differ freely (timeline, grid, table, …).
 */
const Section = ({ id, index, label, title, lead, children }: SectionProps) => (
  <section id={id} className="scroll-mt-28">
    <hr className="rule" aria-hidden="true" />

    <div className="mx-auto max-w-[76rem] px-6 md:px-10 py-20 md:py-28">
      <div className="grid gap-10 lg:grid-cols-[10rem_1fr] lg:gap-16">
        {/* Rail */}
        <div className="lg:sticky lg:top-28 lg:self-start">
          <div className="flex items-baseline gap-3 lg:flex-col lg:items-start lg:gap-2">
            <span className="type-label text-muted-foreground/50 tabular-nums">{index}</span>
            <span className="type-label text-primary">{label}</span>
          </div>
        </div>

        {/* Content */}
        <div>
          {title && (
            <header className={lead ? "mb-5" : "mb-12 md:mb-16"}>
              <h2 className="type-section text-foreground">{title}</h2>
            </header>
          )}
          {lead && (
            <p className="type-lead text-muted-foreground max-w-2xl mb-12 md:mb-16">{lead}</p>
          )}
          {children}
        </div>
      </div>
    </div>
  </section>
);

export default Section;
